import { useCallback } from "react"
import { batch, useComputed } from "@preact/signals-react"
import { FORMAT_DATE_BACK, formatDate, getPreviousDate, translateCountryName } from "@ui-seeker/utils"

import { DATE_PERIODS, GROUPED_BY } from "@constants"
import { isLoadingCommonFilters } from "@signals"
import {
    stockAssDetailsEndDate, stockAssDetailsEvolutionCurrentPeriod, stockAssDetailsSummaryClickFilters, stockAssDetailsSummaryFilters, stockAssDetailsWidgetEvolutionFilters
} from "../../@signals"


export default function useStockWidgetFilters(row, splitKpi) {
    const newFilters = stockAssDetailsSummaryFilters.peek()
    const isClicked = useComputed(() => stockAssDetailsSummaryClickFilters.value?.[row.filterKey] === row.filterValue)

    const handleClick = useCallback(() => {
        const newFilters = {
            ...stockAssDetailsSummaryClickFilters.value,
            ...!isClicked.value ? { [row.filterKey]: row.filterValue } : { [row.filterKey]: null }
        }
        stockAssDetailsSummaryClickFilters.value = Object.fromEntries(
            Object.entries(newFilters).filter(([_, value]) => value != null)
        )
        batch(() => isLoadingCommonFilters.value = true)
    }, [row.filterKey, row.filterValue, isClicked.value])

    const handleClickEvolution = () => {
        stockAssDetailsEvolutionCurrentPeriod.value = DATE_PERIODS.LAST_30_DAYS
        if (splitKpi.includes(GROUPED_BY.COUNTRY)) {
            stockAssDetailsWidgetEvolutionFilters.value = {
                country: row.country,
                splitKpi: splitKpi,
                label: translateCountryName(row.label),
            }
        }

        if (splitKpi.includes(GROUPED_BY.RETAILER)) {
            stockAssDetailsWidgetEvolutionFilters.value = {
                retailer: row.siteID,
                splitKpi: splitKpi,
                label: row.label,
                externalSeller: row.externalSeller,
            }
        }

        if (splitKpi.includes(GROUPED_BY.BRAND)) {
            stockAssDetailsWidgetEvolutionFilters.value = {
                brand: row.brandID,
                splitKpi: splitKpi,
                label: row.label,
            }
        }

        stockAssDetailsEndDate.value = newFilters.currentSingleDate
        let startDate = formatDate(getPreviousDate({days: 29}, stockAssDetailsEndDate.value), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

        stockAssDetailsWidgetEvolutionFilters.value = {
            ...stockAssDetailsWidgetEvolutionFilters.peek(),
            startDate: startDate,
            endDate: stockAssDetailsEndDate.value,
        }
    }

    return {
        isClicked: isClicked.value,
        handleClick,
        handleClickEvolution
    }
}